import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { useGetDropDownCommonCoupon } from 'features/events/use-cases/get-coupon-common';
import { useGetTickets } from 'features/events/use-cases/get-price-category';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
    formId: string;
    handleFilter: (values: any) => void;
    initialValues: any;
    closeModal?: () => void;
};
type CouponStatus = {
    Id: number,
    Title: string
}

export const CouponTabFilterForm = ({
    formId,
    handleFilter,
    initialValues,
    closeModal,
}: UsersFilterFormProps) => {
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<any>();
    const { id } = useParams()
    const { t } = useTranslation();
    const screens = useBreakpoint();
    const commonPayload = {
        PageNo: 1,
        PageSize: 50,
    };

    const { data: statusData } =
        useGetDropDownCommonCoupon({ ...commonPayload, Flag: "STATUS" });

    const { data: EventCategoryData } =
        useGetTickets(id || '', { page: 1, size: 50, order_by: '-name' }, { enabled: !!id });

    const onReset = () => {
        form.resetFields();
        handleFilter({ ...initialValues });
    };

    const onFinish = (formValues: any) => {
        const formattedValues = {
            ...formValues,
            ApplicableOn: formValues.ApplicableOn || undefined,
            value_type: formValues.value_type !== "" && formValues.value_type !== undefined ? formValues.value_type : undefined,
            IsUsagePerUser: formValues.IsUsagePerUser !== "" && formValues.IsUsagePerUser !== undefined ? formValues.IsUsagePerUser : undefined,
        };
        handleFilter(formattedValues);
        closeModal?.();
    };

    return (
        <Form
            id={formId}
            name={formId}
            className='filters-form'
            form={form}
            layout='vertical'
            onFinish={onFinish}
            initialValues={initialValues}
            onFinishFailed={() => {
                setValidateTrigger(['onChange']);
            }}
            validateTrigger={validateTrigger}
        >
            <ContentFilters.FormItemsWrapper>
                <div className='invoice_list cupn_img'>
                    <Form.Item label="Event Category" name="EventCategoryId">
                        <Select
                            showSearch
                            placeholder="Select Category"
                            popupMatchSelectWidth={false}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                String(option?.label)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            options={[
                                { value: " ", label: "All" },
                                ...(EventCategoryData?.items?.map((item: any) => ({
                                    value: item.Id,
                                    label: `${item.Category} (${item?.price_type_name || "Normal"})`,
                                })) || []),
                            ]}
                        />
                    </Form.Item>

                    <Form.Item
                        label={'Coupon Title'}
                        name={"coupon_title"}
                    >
                        <Input placeholder={'Enter Coupon Name'} />
                    </Form.Item>

                    <Form.Item
                        label={'Coupon Code'}
                        name={"coupon_code"}
                    >
                        <Input placeholder={'Enter Coupon Code'} />
                    </Form.Item>

                    <Form.Item label="Status" name="status">
                        <Select
                            placeholder="Select Status"
                            allowClear
                            options={statusData?.DropDownData?.map((item: CouponStatus) => ({
                                value: item.Id,
                                label: item.Title,
                            }))}
                        />
                    </Form.Item>

                    <Form.Item label="Applicable On" name="ApplicableOn">
                        <Select
                            placeholder="Select Applicable On"
                            allowClear
                            options={[
                                { value: "", label: "All" },
                                { value: "EventLevel", label: "Event Level" },
                                { value: "CategoryLevel", label: "Category Level" },
                            ]}
                        />
                    </Form.Item>

                    <Form.Item label="Value Type" name="value_type">
                        <Select
                            placeholder="Select Value Type"
                            allowClear
                            options={[
                                { value: "", label: "All" },
                                { value: 1, label: "Flat" },
                                { value: 2, label: "Percentage" },
                            ]}
                        />
                    </Form.Item>

                    <Form.Item label="Usage Type" name="IsUsagePerUser">
                        <Select
                            placeholder="Select Usage Type"
                            allowClear
                            options={[
                                { value: "", label: "All" },
                                { value: true, label: "Single Use" },
                                { value: false, label: "Multi Use" },
                            ]}
                        />
                    </Form.Item>

                    {screens.lg && (
                        <ContentFilters.ButtonsWrapper className='filter_btn cupon_btn'>
                            <Button type='primary' htmlType='submit'>
                                {t('common.buttons.filter', { count: 1 })}
                            </Button>
                            <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
                        </ContentFilters.ButtonsWrapper>
                    )}
                </div>
            </ContentFilters.FormItemsWrapper>
        </Form>
    );
};
